<div class="main-header">
  <div class="headers">
    <div class="top-header bg-secondary">
      <div class="header-left">
        <div class="app-logo">
          <img
            [routerLink]="['/app/main', { outlets: { content: ['home'], navigation: ['sports'] } }]"
            class="logo"
            [src]="domainService.wlAssetURL + '/logo_light.png'"
            alt="" />
        </div>
        <app-search class="search-wrapper" />
      </div>
      @if (showFeedbackButton) {
        <app-sentry-feedback></app-sentry-feedback>
      }
      <app-balance-display class="balance-display-wrapper" />
    </div>
    <div class="bottom-header bg-primary">
      <div class="b-header-left">
        <app-m-header />
        <div class="powered-by-logo-wrapper">
          <img class="powered-by-logo" [src]="domainService.wlAssetURL + '/powered-by-header.png'" alt="" />
        </div>
        <div class="bottom-nav-divider bg-secondary"></div>
        <div class="nav-items-wrapper">
          <div class="nav-items">
            @for (item of navService.navItems; track item) {
              @let isNavVisible = navService.isSportVisible(item.name.toLowerCase(), "header") | async;
              @if (isNavVisible) {
                @if (item.name === "Casino") {
                  <a (click)="navService.openCasino()" class="nav-item" target="_blank">
                    {{ item.name | translate }}
                  </a>
                } @else {
                  <a [routerLink]="item.path" class="nav-item">
                    {{ item.name | translate }}
                  </a>
                }
              }
            }
          </div>
        </div>
      </div>
      <div class="b-header-right">
        <span class="text-secondary">Welcome, {{ user?.NAME }}</span>
      </div>
    </div>
  </div>
</div>
